import * as React from 'react';

function ComfortIcons({ fontColor, list }) {
  return (
    <div className='grid cols-3 center'>
      {list?.map((step, i) => (
        <div key={i}>
          <img src={step.icon.url} alt={step.description} width={80} />
          <p style={{ color: `#${fontColor}` }}>{step.description}</p>
        </div>
      ))}
    </div>
  );
}
export default ComfortIcons;
